// Public snapshot approved by the owner. Captured from the connected Kre8
// dashboard on 2026-10-27; never load private account data for anonymous visitors.
export const statsPreview = {
  capturedOn: "27 Oct 2026",
  tiktok: { handle: "kre8content", url: "https://www.tiktok.com/@kre8content" },
  instagram: { handle: "kre8_content", url: "https://www.instagram.com/kre8_content/" },
  posts: [
    { title: "How hard did most Streamer University participants fall off?", tiktok: { views: 204230, likes: 11409, comments: 79 }, instagram: { likes: 65, comments: 2 } },
    { title: "Why 80% of Streamer University students failed", tiktok: { views: 28240, likes: 1474, comments: 29 }, instagram: { likes: 39, comments: 3 } },
    { title: "Ludwig was right about Streamer University", tiktok: { views: 18041, likes: 821, comments: 11 }, instagram: { likes: 39, comments: 2 } },
  ],
};
